import React from 'react';
import ReactDOM from 'react-dom';
import 'reset-css'
import './styles/index.scss';
import registerServiceWorker from './registerServiceWorker';
import App from './components/App';

registerServiceWorker();

const render = AppComponent => {
    ReactDOM.render(
        <AppComponent/>,
        document.getElementById('root')
    );
};


render(App);


// WEBPACK FOOTER //
// ./src/index.js